import { render, staticRenderFns } from "./PTTGC_1.vue?vue&type=template&id=3b4dfbe2&"
import script from "./PTTGC_1.vue?vue&type=script&lang=js&"
export * from "./PTTGC_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/kccp/PROD/kccp-portal-web-internet-dynamic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3b4dfbe2', component.options)
    } else {
      api.reload('3b4dfbe2', component.options)
    }
    module.hot.accept("./PTTGC_1.vue?vue&type=template&id=3b4dfbe2&", function () {
      api.rerender('3b4dfbe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/request/new/PTTGC_1.vue"
export default component.exports